import { Expose } from 'class-transformer';
import { FieldType } from 'src/app/settings/model/field-type';
import { ValueField } from 'src/app/settings/model/value-field';
import { UserSettingsService } from 'src/app/settings/service/user-settings.service';
import { DepotDTO } from './depot.dto';

export class Vehicle {
  @Expose({ name: 'veh_id' })
  id: number;
  @Expose({ name: 'veh_side_number' })
  sideNumber: string;
  active: boolean;
  properties: VehicleProperty[];
  groups: number[];
  depot: DepotDTO;
  isSoftwareCurrent: boolean;
  onDepot: boolean;

  static getName(): string {
    return 'Vehicle';
  }
}

export class VehicleProperty {
  [key: string]: string;

  static MAC_ADDRESS = 'mac_address';
  static VEHICLE_LAYOUT_TYPE = 'vehicle_layout_type';
  static VEHICLE_TYPE = 'vehicle_type';
  static INTERNAL_AUDIO = 'internal_audio';
  static EXTERNAL_AUDIO = 'exteranl_audio';
}

export function getVehicleFields(settings?: UserSettingsService): ValueField[] {
  return [
    Object.assign(new ValueField(), {
      name: 'id',
      type: FieldType.INTEGER,
      visible: false,
      primaryKey: true
    }),
    Object.assign(new ValueField(), {
      name: 'sideNumber',
      type: FieldType.TEXT,
      visible: true
    }),
    Object.assign(new ValueField(), {
      name: 'active',
      type: FieldType.BOOLEAN,
      visible: true
    }),
    Object.assign(new ValueField(), {
      name: 'isSoftwareCurrent',
      type: FieldType.BOOLEAN,
      visible: settings ? settings.isEnableDeviceSoftwareUpdate() : false
    })
  ];
};
